import { useMemo } from 'react';
import { IUser, IUserProfile, IUserProfileSimplified } from 'types';

export function useUserHeader(
  user: IUserProfileSimplified | IUserProfile | IUser
) {
  return useMemo(() => {
    if ('name' in user) {
      return {
        name: user.name,
        userId: user.userId,
        rank: user.rank,
        qualification: user.qualification,
        isDiscountCustomer: user.isDiscountCustomer,
        isTeampartner: user.isTeampartner,
        hasSponsorActivity: user.hasSponsorActivity,
        isNewRegistration: user.isNewRegistration,
        isProspect: false,
        country: user.countryCode
      };
    }

    return {
      name:
        user.type === 'Prospect'
          ? user.emails[0].email
          : `${user.givenName ?? ''} ${user.familyName ?? ''}`.trim(),
      userId: user.publicId,
      rank: undefined,
      qualification: undefined,
      isDiscountCustomer:
        user.type === 'BusinessBuilder' &&
        user.classification.includes('DiscountCustomer'),
      isTeampartner: user.type === 'BusinessBuilder',
      isProspect: user.type === 'Prospect',
      hasSponsorActivity: false,
      isNewRegistration: false,
      country: user.addresses[0]?.country
    };
  }, [user]);
}
